import React from 'react';
import { Content, Header, StyledTag, TagsWrapper, Wrapper } from './card-product-preview.styles';
import { RefundMoney } from '@vtbhome/juicyfront/indexIcon';
import { CardCatalogItemProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { ROUTE_ADMIN_PRODUCT_BASE } from '@shared/config/routes/routes';
import { datePeriod } from '@shared/lib/utils/date/date';
import { ProductPhoto } from '../product-photo/product-photo';
import { productPrice } from '@shared/lib/utils/product-price/product-price';

export const CardProductPreview: React.FC<CardCatalogItemProps> = ({
    product,
    isShowBorder = false,
    className,
    onMouseDownPrefetch,
    onHoverPrefetch,
}) => {
    const priceText = productPrice({
        price: product.price,
        withoutPrice: product.isPriceUndefined,
    });
    const productPlace = product.place && `, ${product.place}`;
    return (
        <Wrapper
            to={`${ROUTE_ADMIN_PRODUCT_BASE}/${product.id}`}
            className={className}
            $isShowBorder={isShowBorder}
            onMouseEnter={onHoverPrefetch}
            onMouseDown={onMouseDownPrefetch}>
            <Header $bgColor='primary_20'>
                <ProductPhoto imageUrl={product.imagePath} />
                <TagsWrapper>
                    <StyledTag variant='grey' icon={<RefundMoney size='xs' />}>
                        {priceText}
                    </StyledTag>
                </TagsWrapper>
            </Header>
            <Content>
                <Typography size='body2_short' color='neutral_50'>
                    {datePeriod(product.startAt || '', product.endAt || '')}
                    {Boolean(productPlace) && productPlace}
                </Typography>
                <Typography size='subtitle3' color='neutral_90'>
                    {product.name}
                </Typography>
            </Content>
        </Wrapper>
    );
};
